const { TYPES } = require("./life.type");

const initState = {
  financeLifeAll: null,
  financeLifeOpenWithdraw: false,
};

const financeLifeReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_FINANCE_LIFE_ALL:
      return {
        ...state,
        financeLifeAll: payload,
      };

    // thử nghiệm test ui.
    case TYPES.SET_FINANCE_LIFE_OPEN_WITHDRAW:
      return {
        ...state,
        financeLifeOpenWithdraw: payload,
      };
    default:
      return state;
  }
};

export default financeLifeReducer;
